import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8c4376cc")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Tree = _resolveComponent("Tree")

  return (_openBlock(), _createBlock(_component_Tree, {
    class: "documents-tree",
    value: _ctx.nodes,
    expandedKeys: _ctx.expandedKeys,
    onNodeExpand: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setOpenFolderIcon($event))),
    onNodeCollapse: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setClosedFolderIcon($event)))
  }, {
    default: _withId((slotProps) => [
      _createVNode("i", {
        class: ["p-mr-2", slotProps.node.customIcon]
      }, null, 2),
      (slotProps.node.selectable)
        ? (_openBlock(), _createBlock(_component_Checkbox, {
            key: 0,
            name: "folders",
            modelValue: _ctx.selectedFolders,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFolders = $event)),
            value: slotProps.node.path,
            onChange: _ctx.emitSelectedFolders
          }, null, 8, ["modelValue", "value", "onChange"]))
        : _createCommentVNode("", true),
      _createVNode("b", null, _toDisplayString(slotProps.node.label), 1)
    ]),
    _: 1
  }, 8, ["value", "expandedKeys"]))
})